import React, { Component } from 'react'
import Tabletop from 'tabletop'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/divider.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/table.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/card.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/loader.css'

import { hot } from 'react-hot-loader'
import './styles.scss'

import { Masthead } from '@ta-interaktiv/react-masthead'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Waypoint } from 'react-waypoint'
import { ArticleTeasers } from '@ta-interaktiv/react-article-teasers'
import { Footer } from '@ta-interaktiv/react-footer'

const articleTeaserDefaultProperties = {
  numberOfCards: 'three',
  className: 'doubling stackable'
}
const ADDITIONAL_SHARES = 392 + 645 + 651 + 1228

// Only Trigger Waypoints once -> switch variable after waypoint to true
const singleTriggerStartReading = false
let singleTrigger20ContentRead = false
let singleTrigger50ContentRead = false
const singleTriggerContentBottom = false
const singleTriggerPageBottom = false

class AppComponent extends Component {
  static defaultProps = {
    articleId: '525652440865'
  }

  constructor(props) {
    super(props)

    this.state = {
      cardsHighlightsEditorial: [],
      cardsRecommendedEditorial: [],
      cardsView: [],
      cardsShared: [],
      cardsCommented: [],
      listOfArticles: [],
      time: '',
      request: 'loading'
    }
  }

  linkClick(e) {
    const currentLink = e.currentTarget.getAttribute('data-link')
    const currentCategory = e.currentTarget.getAttribute('category')
    // console.log('currentLink: ', currentLink)

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: currentCategory + ': ' + currentLink
    })
  }

  componentDidMount() {
    Tabletop.init({
      key:
        'https://docs.google.com/spreadsheets/d/1Pkr4II8GwZ-E86K-0CuGZgvNx50-A-R2cxLXGOw0-QA/edit?usp=sharing',
      callback: data => {
        this.setState({
          listOfArticles: data,
          request: 'success'
        })
        const firstArticle = data[0]
        // console.log(firstArticle.lastUpDate + 'ZEIT')
        this.setState({
          time: firstArticle.lastUpDate
        })

        this.setState({
          cardsHighlightsEditorial: data
            .map(d => d.highlightsEditorial)
            .slice(0, 3),
          cardsRecommendedEditorial: data
            .map(d => d.recommendedEditorial)
            .slice(0, 3),
          cardsView: data.map(d => d.mostRead).slice(0, 3),
          cardsShared: data.map(d => d.mostShared).slice(0, 3),
          cardsCommented: data.map(d => d.mostCommented).slice(0, 3)
        })
      },
      simpleSheet: true
    })
  }

  getTime = () => {
    return (
      <div>
        <p className='time'>
          <span className='update'>Letztes Update</span>: {this.state.time}.
        </p>
      </div>
    )
  }

  onEnter = id => {
    // console.log("ID", id)
    // console.log('onEnter function')
    window.header.setHeaderId(id)
  }

  render() {
    return (
      <div className='index'>
        <ThemeSwitch />
        <Masthead
          additionalShares={ADDITIONAL_SHARES}
          inverted
          enablePaywall={false}
          articleId={this.props.articleId}
        />

        {/* Start Reading Waypoint handled by Masthead */}

        <header className='ui vertical fitted segment headerSegment'>
          <div className='ui text container intro'>
            <div className='intro'>
              <h2 className='introTitle'>
                <span style={{ fontWeight: 200 }}>Der</span> Abend
              </h2>
              <h2 className='introTitleTwo'>
                <span className='day'>kompakt</span>
              </h2>
            </div>
            <div>
              <h4 className='introSubtitle'>
                Jeden Tag die besten Geschichten um 16:30&nbsp;Uhr.
              </h4>
            </div>

            <div>{this.getTime()}</div>
          </div>
        </header>

        <div
          className={`ui ${this.state.request} vertical segment articleSegment`}
        >
          <div className='ui container section'>
            <div className='titleWrapper'>
              <h2 className='categoryTitle'>Das Wichtigste des Tages</h2>
              <p className='categorySubtitle'>Auswahl der Tagesleitung</p>
            </div>
            <div className='ui inverted divider' />
          </div>

          <Waypoint
            onLeave={event => {
              if (
                event.previousPosition === Waypoint.inside &&
                event.currentPosition === Waypoint.above &&
                singleTrigger20ContentRead === false
              ) {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: '20ContentRead'
                })
                singleTrigger20ContentRead = true
              }
            }}
          />

          <div className='ui container'>
            {navigator.userAgent !== 'ReactSnap' && (
              <ArticleTeasers
                {...articleTeaserDefaultProperties}
                articleIds={this.state.cardsHighlightsEditorial}
              />
            )}
          </div>

          <div className='ui container section'>
            <div className='titleWrapper'>
              <h2 className='categoryTitle'>Die Redaktion empfiehlt</h2>
              <p className='categorySubtitle'>Auswahl der Tagesleitung</p>
            </div>
            <div className='ui inverted divider' />
          </div>

          <div className='ui container'>
            {navigator.userAgent !== 'ReactSnap' && (
              <ArticleTeasers
                {...articleTeaserDefaultProperties}
                articleIds={this.state.cardsRecommendedEditorial}
              />
            )}
          </div>

          <div className='ui container section'>
            <div className='titleWrapper'>
              <h2 className='categoryTitle'>Meistgelesen</h2>
              <p className='categorySubtitle'>
                Was die Leser in den letzten 24h klickten
              </p>
            </div>
            <div className='ui inverted divider' />
          </div>

          <div className='ui container'>
            {navigator.userAgent !== 'ReactSnap' && (
              <ArticleTeasers
                {...articleTeaserDefaultProperties}
                articleIds={this.state.cardsView}
              />
            )}
          </div>

          <Waypoint
            scrollableAncestor={window}
            onEnter={event => {
              if (
                event.previousPosition === Waypoint.below &&
                singleTrigger50ContentRead === false
              ) {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: '50ContentRead'
                })

                singleTrigger50ContentRead = true
                // console.log(singleTrigger50ContentRead)
              }
            }}
          />

          <div className='ui container section'>
            <div className='titleWrapper'>
              <h2 className='categoryTitle'>Meistkommentiert</h2>
              <p className='categorySubtitle'>
                Worüber die Leser in den letzten 24h diskutierten
              </p>
            </div>
            <div className='ui inverted divider' />
          </div>

          <div className='ui container'>
            {navigator.userAgent !== 'ReactSnap' && (
              <ArticleTeasers
                {...articleTeaserDefaultProperties}
                articleIds={this.state.cardsCommented}
              />
            )}
          </div>

          <div className='ui container section'>
            <div className='titleWrapper'>
              <h2 className='categoryTitle'>Meistgeteilt</h2>
              <p className='categorySubtitle'>
                Was die Leser in den letzten 24h empfahlen
              </p>
            </div>
            <div className='ui inverted divider' />
          </div>

          <div className='ui container'>
            {navigator.userAgent !== 'ReactSnap' && (
              <ArticleTeasers
                {...articleTeaserDefaultProperties}
                articleIds={this.state.cardsShared}
                numberOfCards='three'
              />
            )}
          </div>
        </div>

        <Footer
          additionalShares={ADDITIONAL_SHARES}
          articleId={this.props.articleId}
          topHalfClassName={'basic'}
          invertedTop
          credits={[
            [
              'Programmierung und digitale Umsetzung',
              'Patrick Vögeli, Amir Mustedanagic und Marc Brupbacher'
            ]
          ]}
          questions={['Wie nützlich finden Sie diese tägliche Übersicht?']}
        />
      </div>
    )
  }
}

export default hot(module)(AppComponent)
